<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="3">
        <v-card class="pa-4">
          <div class="text-subtitle-2 grey--text">Реферальный код</div>
          <div class="text-h6">{{ profile.referalCode }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4">
          <div class="text-subtitle-2 grey--text">Доступно к выводу</div>
          <div class="text-h6">{{ profile.availableBalance | toCurrency }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4">
          <div class="text-subtitle-2 grey--text">Ожидается</div>
          <div class="text-h6">{{ profile.pendingBalance | toCurrency }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4">
          <div class="text-subtitle-2 grey--text">Выплачено</div>
          <div class="text-h6">{{ profile.paidBalance | toCurrency }}</div>
        </v-card>
      </v-col>
    </v-row>

    <v-btn
      color="primary"
      class="my-4"
      :disabled="profile.availableBalance <= 0 || profile.hasOpenRequest"
      :loading="withdrawing"
      @click="Withdraw"
    >
      Вывести средства ({{ profile.availableBalance | toCurrency }})
    </v-btn>

    <v-data-table :headers="headers" :items="requests" :items-per-page="10">
      <template v-slot:item.amount="{ item }">{{ item.amount | toCurrency }}</template>
      <template v-slot:item.dateCreated="{ item }">{{ new Date(item.dateCreated).toLocaleString() }}</template>
      <template v-slot:item.paidDate="{ item }">
        {{ item.paidDate ? new Date(item.paidDate).toLocaleString() : "—" }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: "PartnerBalance",
  data: () => ({
    profile: { referalCode: "", availableBalance: 0, pendingBalance: 0, paidBalance: 0, hasOpenRequest: false },
    requests: [],
    withdrawing: false,
    headers: [
      { text: "№", value: "id" },
      { text: "Дата", value: "dateCreated" },
      { text: "Сумма", value: "amount" },
      { text: "Статус", value: "statusName" },
      { text: "Комментарий менеджера", value: "managerComment" },
      { text: "Дата выплаты", value: "paidDate" },
    ],
  }),
  created() {
    this.Load();
  },
  methods: {
    async Load() {
      this.profile = await this.$store.dispatch("GET_PARTNER_PROFILE");
      this.requests = await this.$store.dispatch("GET_PARTNER_PAYOUTS");
    },
    async Withdraw() {
      this.withdrawing = true;
      try {
        await this.$store.dispatch("CREATE_PAYOUT_REQUEST");
        this.$store.commit("SET_SNACKBAR", {
          show: true, text: "Заявка на вывод создана", color: "success", timeout: 3000,
        });
      } catch (err) {
        window.console.log(err);
      } finally {
        await this.Load();
        this.withdrawing = false;
      }
    },
  },
};
</script>
